import { render, staticRenderFns } from "./DebtorForm.vue?vue&type=template&id=bfeffe7a&scoped=true&"
import script from "./DebtorForm.vue?vue&type=script&lang=js&"
export * from "./DebtorForm.vue?vue&type=script&lang=js&"
import style0 from "./DebtorForm.vue?vue&type=style&index=0&id=bfeffe7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeffe7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VContainer,VRadio})
